import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const AppDevJobsGurugram = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <Helmet>
        <title>{`App Development Jobs in Gurugram | Latest Openings ${currentYear}`}</title>
        <meta
          name="description"
          content="Find the latest App Development Jobs in Gurugram NCR. Explore Android, iOS, and cross-platform app developer openings for freshers and experienced candidates. Apply today with JobsInDelhiNCR."
        />
        <meta
          name="keywords"
          content="app development jobs in Gurugram, android developer jobs Gurugram, iOS developer jobs Gurugram, mobile app developer jobs Gurugram NCR, react native developer jobs Gurugram, flutter developer jobs Gurugram, app developer fresher jobs Gurugram, hybrid app developer jobs Gurugram, full stack app developer jobs Gurugram"
        />
        <meta name="author" content="JobsInDelhiNCR" />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://jobsindelhincr.in/appdevelopment-jobs-in-gurugram"
        />
      </Helmet>

      <Navbar />

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          App Development Jobs in Gurugram – Latest Openings {currentYear}
        </h1>

        <p className="text-gray-600 mb-6">
          Searching for <strong>App Development Jobs in Gurugram NCR</strong>? Explore the latest openings for Android, iOS, and hybrid app developers. Whether you’re a fresher or an experienced developer, find the perfect opportunity to build your career in app development today.
        </p>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Top Companies Hiring App Developers in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Tech Mahindra</li>
          <li>Wipro</li>
          <li>TCS</li>
          <li>Accenture</li>
          <li>Infosys</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-700 mb-4">
          Popular App Developer Roles in Gurugram
        </h2>
        <ul className="list-disc list-inside text-gray-600 mb-6">
          <li>Android Developer Jobs in Gurugram</li>
          <li>iOS Developer Jobs in Gurugram</li>
          <li>React Native Developer Jobs in Gurugram</li>
          <li>Flutter Developer Jobs in Gurugram</li>
          <li>Full Stack App Developer Jobs in Gurugram</li>
          <li>Mobile App UI/UX Developer Jobs in Gurugram</li>
          <li>App Tester Jobs in Gurugram</li>
          <li>Hybrid App Developer Jobs in Gurugram</li>
          <li>Junior App Developer Jobs in Gurugram</li>
          <li>Senior App Developer Jobs in Gurugram</li>
        </ul>

        <p className="text-gray-600">
          Start your career with <strong>jobsindelhincr.in</strong> — your trusted job portal for verified <strong>App Development Jobs in Gurugram</strong>. Apply directly without registration and find your next opportunity today!
        </p>
      </div>

      <Footer />
    </>
  );
};

export default AppDevJobsGurugram;
